import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { getProjectList } from '../../requests/snp.request';
import { AgricultureWrapper, EducationContainer, EducationItem } from './index.styles';
import { transformList } from './education.component';
import ZoomableImageModal from './zoomable-image.component';
import AdditionalFields from '../reportComponents/additional-fields.component';
import ImageGrid from '../reportComponents/image-grid.component';
import { checkNonEmpty, checkVal, getLang } from '../../utils/helpers.utils';
import { ArrowDown } from '../../assets/icons';

const Investment = ({ kato }: { kato: number }) => {

  const { t, i18n: { language } } = useTranslation();

  const [projectList, setProjectList] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [currentImageList, setCurrentImageList] = useState<any[]>([]);
  const [objectName, setObjectName] = useState<string>('Фото')
  const [isAllOpen, setIsAllOpen] = useState<boolean>(false);
  const [isListOpen, setIsListOpen] = useState<{ [key: string]: boolean }>({});

  const handleOpen = (id: any) => {
    setIsListOpen(prev => ({ ...prev, [id]: !prev[id] }));
  }

  const handleOpenAll = () => {
    const obj = Object.keys(isListOpen).reduce((acc: any, key: any) => {
      acc[key] = !isAllOpen;
      return acc;
    }, {})

    setIsListOpen(obj);
  }

  useEffect(() => {
    const obj = projectList.reduce((acc: any, street: any) => {
      acc[street.id] = projectList.length < 3;
      return acc;
    }, {})
    setIsListOpen(obj);

    setIsAllOpen(Object.values(obj).every((value: any) => value === true));
  }, [projectList])

  useEffect(() => {
    setIsAllOpen(Object.values(isListOpen).every((value: any) => value === true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.values(isListOpen)])

  const openImageModal = (image: any, images: any, name: string) => {
    setIsOpen(true);
    setSelectedImage(image);
    const imageIdList = images.reduce((acc: any, item: any) => [...acc, ...item.imageIds], []);
    setCurrentImageList(imageIdList);
    setObjectName(name);
  }

  const closeImageModal = () => {
    setIsOpen(false);
    setSelectedImage(null);
    setCurrentImageList([]);
  }

  useEffect(() => {
    const snpData = JSON.parse(localStorage.getItem('snp') as string);
    const val = kato ? kato : snpData.kato
    if (val) {
      getProjectList('SNP_INVESTMENT', val)
        .then((res) => {
          const filtered = res.filter((project: any) => Object.keys(project).some((key) => !['id', 'kato'].includes(key) && checkVal(project[key]) && checkNonEmpty(project[key])));
          setProjectList(transformList(filtered));
        })
        .catch((err) => {
          toast.error('Снп не выбрано');
        })
    }
  }, [])

  useEffect(() => {
    getProjectList('SNP_INVESTMENT', kato)
      .then((res) => {
        const filtered = res.filter((project: any) => Object.keys(project).some((key) => !['id', 'kato'].includes(key) && checkVal(project[key]) && checkNonEmpty(project[key])));
        setProjectList(transformList(filtered));
      })
      .catch((err) => {
        toast.error('Снп не выбрано');
      })
  }, [kato])

  if (projectList.length === 0) {
    return <p>{t('no-objects-investment')}</p>
  }

  return (
    <AgricultureWrapper>
      <div className='list-heading with-icon' onClick={handleOpenAll}>
        {t('list')}
        <ArrowDown width="12" style={{ transform: isAllOpen ? 'rotate(180deg)' : 'rotate(270deg)' }} />
      </div>
      <EducationContainer>
        {projectList.length > 0 && projectList.map((project) =>
          <EducationItem key={project.id}>
            <div className="heading with-icon" onClick={() => handleOpen(project.id)}>
              <ArrowDown width="12" style={{ transform: isAllOpen ? 'rotate(180deg)' : 'rotate(270deg)' }} />
              {project[`name${getLang()}`] || `${t('object-name')} ${project.id}`}
            </div>

            {isListOpen[project.id] && <div className='body'>
              {['realizationYear', `projectPower${getLang()}`, 'investmentFund', 'workPlaceNumber'].some((key) => checkVal(project[key]))
                && <div className='items'>
                  {
                    checkVal(project.constructionYear)
                    && <div className='item'>
                      <div>
                        {t('snp_investment.realizationYear')}:
                        <b>{new Date(project.realizationYear).getFullYear()}</b>
                      </div>
                    </div>
                  }
                  {
                    checkVal(project[`projectPower${getLang()}`])
                    && <div className='item'>
                      <div>
                        {t(`snp_investment.projectPower`)}:
                        <b>{project[`projectPower${getLang()}`]}</b>
                      </div>
                    </div>
                  }
                  {
                    checkVal(project.investmentFund)
                    && <div className='item'>
                      <div>
                        {t('snp_investment.investmentFund').split(',')[0]}:
                        <b>{project.investmentFund} млн {t('tenge')}</b>
                      </div>
                    </div>
                  }
                  {
                    checkVal(project.workPlaceNumber)
                    && <div className='item'>
                      <div>
                        {t('snp_investment.workPlaceNumber')}:
                        <b>{project.workPlaceNumber}</b>
                      </div>
                    </div>
                  }
                </div>}

              {
                (project[`shortDescription${language[0].toUpperCase() + language.slice(1)}`] || project[`expectedEffect${language[0].toUpperCase() + language.slice(1)}`]) && <>
                  <div className="block" style={{ padding: 0, border: 0 }}>
                    <div className="text">{t('snp_investment.shortDescription')}: {project[`shortDescription${language[0].toUpperCase() + language.slice(1)}`]}</div>
                    <div className="text">{t('snp_investment.expectedEffect')}: <b>{project[`expectedEffect${language[0].toUpperCase() + language.slice(1)}`]}</b></div>
                  </div>
                </>
              }

              {checkVal(project.additionalFields) && Object.keys(project.additionalFields).filter((key: string) => !['ru', 'kz'].includes(key)).length > 0 && <AdditionalFields project={project} />}

                              {project.images && <ImageGrid images={project.images} openImageModal={openImageModal} name={project[`name${getLang()}`] || `${t('object-name')} ${project.id}`} />}

            </div>}

          </EducationItem>
        )}
        <ToastContainer />
      </EducationContainer>
      {selectedImage && (
        <ZoomableImageModal
          isFileUpload={true}
          isOpen={isOpen}
          onClose={closeImageModal}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          currentImageList={currentImageList}
          objectName={objectName}
        />
      )}
    </AgricultureWrapper>

  )
}

export default Investment